import { PlusOutlined } from "@ant-design/icons";

import BaseButton from "@/shared/ui/BaseButton";
import { FloatingActionButton } from "@/shared/ui/FloatingActionButton";

import { StyledControlsContainer } from "../Styled";

interface AddPointControlsBlockProps {
    checkedPointsCount: number;
    updateLoading: boolean;
    onUpdatePoint: () => void;
    onCreatePoint: () => void;
}

export const AddPointControlsBlock = ({
    checkedPointsCount,
    updateLoading,
    onUpdatePoint,
    onCreatePoint,
}: AddPointControlsBlockProps) => {
    return (
        <StyledControlsContainer>
            <BaseButton
                type="primary"
                onClick={onUpdatePoint}
                disabled={!checkedPointsCount}
                loading={updateLoading}
            >
                Зберегти
            </BaseButton>

            <FloatingActionButton
                onClick={onCreatePoint}
                icon={<PlusOutlined />}
                right={16}
                top={-50}
                disabled={updateLoading}
            />
        </StyledControlsContainer>
    );
};
